//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './GDTIncomingMessageClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type ReceiveGDTIncomingMessageQueryParameters = {
  content?: string | undefined ;
}

export function receiveUrl(content?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/gdt/incoming-messages?";
if (content === null)
    throw new Error("The parameter 'content' cannot be null.");
else if (content !== undefined)
    url_ += "content=" + encodeURIComponent("" + content) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function receiveMutationKey(content?: string | undefined): MutationKey {
  return trimArrayEnd([
      'GDTIncomingMessageClient',
      'receive',
      content as any,
    ]);
}

export function useReceiveMutation<TContext>(content?: string | undefined, options?: Omit<UseMutationOptions<Types.GDTMessageDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.GDTMessageDto, unknown, void, TContext> {
  const key = receiveMutationKey(content);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.receive(content),
    mutationKey: key,
  });
}
  
type Receive__MutationParameters = ReceiveGDTIncomingMessageQueryParameters

export function useReceiveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.GDTMessageDto, unknown, Receive__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ReceiveGDTIncomingMessageQueryParameters}): UseMutationResult<Types.GDTMessageDto, unknown, Receive__MutationParameters, TContext> {
  const key = receiveMutationKey(options?.parameters?.content!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Receive__MutationParameters) => Client.receive(data.content ?? options?.parameters?.content!),
  mutationKey: key,
});
}